import axios from 'axios';
import env from 'react-dotenv';
import { checkVAT, countries } from 'jsvat';

import { AVAILABLE_COUNTRIES } from '../common/other';
import { logError } from './logError';

export const googleAddressValidation = async (values) => {
    if (env.ENV_NAME === 'Production' || env.ENV_NAME !== 'Production') {
        return {}
    }

    // Regions available on website but without google address validation
    // check here for updates: https://developers.google.com/maps/documentation/address-validation/coverage
    if (["Bulgaria", "Cyprus", "Malta", "Greece", "Romania"].includes(values.country)) {
        return {}
    }

    const URL = `https://addressvalidation.googleapis.com/v1:validateAddress?key=${env.GOOGLE_MAPS_APIKEY}`;

    try {
        const response = await axios.post(URL, {
            address: {
                regionCode: AVAILABLE_COUNTRIES[values.country],
                postalCode: values.postalCode,
                locality: values.city,
                addressLines: [`${values.street}`],
            },
        });
        if (response.status === 200) {
            return response.data.result.address;
        }
    } catch (err) {
        logError(err);
        throw err;
    }
};


export const vatNumberValidation = async (country, vatNumber) => {
    let countryCode = AVAILABLE_COUNTRIES[country];

    if (vatNumber.substring(0, 2) === countryCode) {
        countryCode = '';
    }
    
    return checkVAT(countryCode + vatNumber, countries)?.isValid ?? false;
};
